import { createTheme } from '@mui/material/styles';
import { teal } from '@mui/material/colors';

const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          width: '100%',
          '& .MuiInput-root:before': {
            content: 'unset'
          },
          '& .MuiInput-root:after': {
            content: 'unset'
          },
          '& .MuiInput-root.Mui-focused:after': {
            content: 'unset'
          },
          '& .MuiInput-underline': {
            border: '2px solid rgba(0, 0, 0, 0.42)'
          },
          '& .Mui-focused': {
            border: '2px solid rgba(0, 0, 0, 0.42)',
            transform: 'unset'
          },
          '&.textField': {
            '& .MuiInput-root': {
              borderRadius: '3px'
            },
            input: {
              border: 0,
              padding: '10px 10px'
            }
          },
          '&.textarea': {
            textarea: {
              width: '100%',
              border: 0,
              padding: '0 10px'
            }
          }
        }
      }
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            backgroundColor: teal[500],
            color: 'white',
            textTransform: 'none',
            borderRadius: '3px',
            fontWeight: '400',
            boxShadow: 'inset 0 -3px 0 0 #0c786a',
            fontSize: '1rem',
            padding: '6px 20px',
            textDecoration: 'none',
            '&:hover': {
              backgroundColor: teal[300]
            },
            '&:focus': {
              outline: 'none'
            }
          }
        },
        {
          props: { variant: 'text', color: 'secondary' },
          style: {
            backgroundColor: 'transparent',
            color: '#004BD6',
            textDecoration: 'underline',
            textTransform: 'none',
            fontSize: '14px',
            padding: '0px',
            '&:hover': {
              backgroundColor: 'transparent'
            },
            '&:focus': {
              outline: 'none'
            }
          }
        }
      ]
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#333',
          color: '#FFF',
          fontSize: '12px'
        },
      },
    },
  }
});

export default theme;
